import { CxTabViewContentService } from './components/cx-tab-view-content/cx-tab-view-content.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LibsRoutingModule } from './libs-routing.module';
import { CxButtonComponent } from './components/cx-button/cx-button.component';
import { CxButtonPdfComponent } from './components/cx-button-pdf/cx-button-pdf.component';
import { CxBrandColorBarComponent } from './components/cx-brand-color-bar/cx-brand-color-bar.component';
import { CxAlertsComponent } from './components/cx-alerts/cx-alerts.component';
import { CxHeaderTooltipComponent } from './components/cx-header-tooltip/cx-header-tooltip.component';
import { CxHeaderTooltipButtonComponent } from './components/cx-header-tooltip-button/cx-header-tooltip-button.component';
import { CxCheckBoxComponent } from './components/cx-check-box/cx-check-box.component';
import { CxAccordionComponent } from './components/cx-accordion/cx-accordion.component';
import { CxAccordionPanelComponent } from './components/cx-accordion-panel/cx-accordion-panel.component';
import { CxTabViewComponent } from './components/cx-tab-view/cx-tab-view.component';
import { CxTabViewTabComponent } from './components/cx-tab-view-tab/cx-tab-view-tab.component';
import { CxTabViewContentComponent } from './components/cx-tab-view-content/cx-tab-view-content.component';
import { CxCardHeaderComponent } from './components/cx-card-header/cx-card-header.component';
import { CxSpinnerComponent } from './components/cx-spinner/cx-spinner.component';
import { CxDropdownContainerComponent } from './components/cx-dropdown-container/cx-dropdown-container.component';
import { CxDropdownItemComponent } from './components/cx-dropdown-item/cx-dropdown-item.component';
import { CxFormGroupComponent } from './components/cx-form-group/cx-form-group.component';
import { CxFormSubGroupComponent } from './components/cx-form-sub-group/cx-form-sub-group.component';
import { CxFieldComponent } from './components/cx-field/cx-field.component';
import { CxAutoFillComponent } from './components/cx-auto-fill/cx-auto-fill.component';
import { CxErrorMessageComponent } from './components/cx-error-message/cx-error-message.component';
import { CxRadioButtonComponent } from './components/cx-radio-button/cx-radio-button.component';
import { CxFormSubGroupRowComponent } from './components/cx-form-sub-group-row/cx-form-sub-group-row.component';
import { CxUploadFilesComponent } from './components/cx-upload-files/cx-upload-files.component';
import { CxErrorMessageGroupComponent } from './components/cx-error-message-group/cx-error-message-group.component';
import { CxDatepickerComponent } from './components/cx-datepicker/cx-datepicker.component';
// import { CxCardTmpComponent } from './components/cx-card-tmp/cx-card-tmp.component';



@NgModule({
  declarations: [
    CxAlertsComponent,
    CxButtonComponent,
    CxButtonPdfComponent,
    CxBrandColorBarComponent,
    CxHeaderTooltipComponent,
    CxHeaderTooltipButtonComponent,
    CxCheckBoxComponent,
    CxAccordionComponent,
    CxAccordionPanelComponent,
    CxTabViewComponent,
    CxTabViewTabComponent,
    CxTabViewContentComponent,
    CxCardHeaderComponent,
    CxSpinnerComponent,
    CxDropdownContainerComponent,
    CxDropdownItemComponent,
    CxFormGroupComponent,
    CxFormSubGroupComponent,
    CxFieldComponent,
    CxAutoFillComponent,
    CxErrorMessageComponent,
    CxRadioButtonComponent,
    CxFormSubGroupRowComponent,
    CxUploadFilesComponent,
    CxErrorMessageGroupComponent,
    CxDatepickerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    LibsRoutingModule,
    ReactiveFormsModule
  ],
  exports: [
    CxAlertsComponent,
    CxButtonComponent,
    CxButtonPdfComponent,
    CxBrandColorBarComponent,
    CxHeaderTooltipComponent,
    CxCheckBoxComponent,
    CxHeaderTooltipButtonComponent,
    CxAccordionComponent,
    CxAccordionPanelComponent,
    CxTabViewComponent,
    CxTabViewTabComponent,
    CxTabViewContentComponent,
    CxCardHeaderComponent,
    CxSpinnerComponent,
    CxDropdownContainerComponent,
    CxDropdownItemComponent,
    CxFormGroupComponent,
    CxFormSubGroupComponent,
    CxFieldComponent,
    CxAutoFillComponent,
    CxErrorMessageComponent,
    CxRadioButtonComponent,
    CxFormSubGroupRowComponent,
    CxUploadFilesComponent,
    CxDatepickerComponent,
    CxErrorMessageGroupComponent
  ]
})
export class LibsModule { }
